import { PauseIcon, PlayIcon } from "@phosphor-icons/react/ssr";

import AuthorInfo from "./AuthorInfo";
import { cn } from "~/lib/utils";
import { type VideoBottomTestimonialV3, VideoTrackingConfig } from "./data";
import VideoPlayer from "~/componentsDS/VideoPlayer";
import { useVideoTestimonial } from "./useVideoTestimonial";

type VideoBottomSlideProps = {
    testimonial: VideoBottomTestimonialV3;
    trackingConfig?: VideoTrackingConfig;
    className?: string;
};

const VideoBottomSlide = ({ testimonial, trackingConfig, className }: VideoBottomSlideProps) => {
    const { poster, mp4, hls, author, text } = testimonial;

    const { videoRef, videoStarted, onClick, onVideoPlay, onVideoPause } = useVideoTestimonial(
        { mp4, author, text },
        trackingConfig,
    );

    return (
        <div className={cn("h-[514px] flex flex-col overflow-hidden", className)}>
            <div className="bg-[#E9EDF7] rounded-3xl flex flex-col p-4 md:p-6">
                <p className="relative font-suisseBP font-normal text-[20px] leading-[1.4] text-primary500 mb-5">
                    <span className="absolute -translate-x-full">&ldquo;</span>
                    {text}&rdquo;
                </p>

                <AuthorInfo author={author} />
            </div>

            <div className="vsl-player-sm-2 rounded-3xl overflow-hidden w-full relative mt-4 grow hover:scale-95 duration-500">
                <VideoPlayer
                    ref={videoRef}
                    mp4={mp4}
                    hls={hls}
                    width="304"
                    height="288"
                    poster={poster}
                    title={author}
                    controlsList="nofullscreen"
                    preload="none"
                    playsInline
                    onClick={onClick}
                    onPlay={onVideoPlay}
                    onPause={onVideoPause}
                    className={cn("nofullscreen w-full min-h-full aspect-[352/276] object-cover object-[50%_25%] bg-trueBlack", testimonial.videoClassName)}
                />

                <div className="absolute inset-0 bg-trueBlack/20 pointer-events-none"></div>

                <button className={cn(
                    "w-14 h-14 flex items-center justify-center border-2 border-pureWhite/25 bg-pureWhite/5 backdrop-blur-md rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                    videoStarted ? "opacity-0 group-hover:animate-[fade-out_2s_forwards]" : "",
                )} onClick={onClick}>
                    {videoStarted ? <PauseIcon weight="fill" size={28} fill="white" /> : <PlayIcon weight="fill" size={28} fill="white" /> }
                </button>
            </div>
        </div>
    );
};

export default VideoBottomSlide;
